export default __webpack_public_path__ + "static/media/webtable.391d1608.png";